@import '~style-sheet-helpers/core.less';
@import '../../../../../../constants/screen-width-breakpoints.module.less';
@import '../../../../../../constants/spacing.module.less';

.header {
  font-weight: 700;
}
.orders-step {
  margin: 0 10%;
  text-align: left;

  @media @mobile, @ultramobile {
    margin: 0;
  }
}

.setup-marketplace-option {
  width: 80%;
  height: 545px;
  overflow: hidden;
  margin: @space-24 auto 0;

  @media @mobile, @ultramobile {
    width: 100%;
    height: calc(100vh - 50px);
  }

  div,
  iframe {
    border: 0;
    height: 100%;
    width: 100%;
  }
}

.import-marketplace-orders {
  display: flex;
  flex-direction: column;
  gap: @space-16;
  width: 80%;
  margin: @space-16 auto;

  @media @mobile, @ultramobile {
    width: 100%;
  }
}

.marketplace-icon,
.info-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.connected-store-item {
  padding: @space-16;
  border: 1px solid var(--gray-E4E5E7);
  border-radius: 8px;
  background-color: var(--white);
}

.store-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.store-info {
  display: flex;
  align-items: center;
  gap: @space-12;
}

.store-icon {
  width: 24px;
}

.connection-status {
  color: var(--green-0D6E3F);
  font-size: 12px;
  background-color: var(--green-EDFDF5);
  border: 1px solid var(--green-B6F6D7);
  padding: 6px;
  border-radius: 4px;
  margin-left: 8px;
  display: flex;
  align-items: center;
  gap: @space-4;
}

.connection-status-dot {
  font-size: 28px;
  line-height: 10px;
  height: auto;
}

.info-message {
  display: flex;
  align-items: flex-start;
  gap: @space-12;
  padding: @space-12 @space-16;
  background-color: var(--blue-EDF6FF);
  border-radius: 4px;
  font-size: 14px;
  margin-top: @space-12;
}

.info-icon {
  height: 14px;
  width: 14px;
  color: var(--blue-1D5AD8);
}

.connect-another-store {
  text-align: left;
}

.connect-another-store:hover {
  text-decoration: underline;
}

.import-status-success {
  display: flex;
  align-items: center;
  gap: @space-4;
}

.completed-icon {
  width: 18px;
  height: 18px;
  margin-right: 2px;
  color: var(--green-05b45e);
}

.import-status-success-icon {
  color: var(--green-0D6E3F);
  font-size: 16px;
}

.import-status-in-progress {
  display: flex;
  align-items: center;
  gap: @space-4;
}

.import-status-success,
.import-status-in-progress,
.import-status-queued,
.import-status-error,
.import-status-unknown {
  display: flex;
  align-items: center;
  gap: @space-4;
  color: var(--gray-212c36);
}

.import-status-queued {
  color: var(--blue-1D5AD8);
}

.import-status-error {
  font-weight: 600;
  color: var(--red-FF4422);
}

.import-status-unknown {
  color: var(--gray-8D9196);
}

.error-icon {
  width: 14px;
  height: 14px;
  margin-right: 2px;
  color: var(--red-FF4422);
}

.loading-indicator {
  height: 32px;
  width: 32px;
}

.error-message {
  display: flex;
  align-items: flex-start;
  gap: @space-12;
  padding: @space-12 @space-16;
  background-color: var(--purple-f8dede);
  border-radius: 4px;
  font-size: 14px;
  margin-top: @space-12;
  color: var(--red-FF4422);
}

.simplified-dropdown-container {
  width: 80%;
  margin: @space-48 auto 0;

  @media @mobile, @ultramobile {
    width: 100%;
    margin-top: @space-24;
  }
}

.simplified-dropdown {
  text-align: left;
}

.simplified-upload-container {
  width: 80%;
  margin: @space-24 auto 0;

  @media @mobile, @ultramobile {
    width: 100%;
  }
}

.upload-section {
  border: 1px solid var(--gray-E4E5E7);
  border-radius: 8px;
  padding: @space-24;
  background-color: var(--white);
}

.upload-header {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: @space-16;
  text-align: left;
}

.upload-content {
  display: flex;
  flex-direction: column;
  gap: @space-16;
}

.upload-controls {
  display: flex;
  gap: @space-16;
  align-items: flex-end;

  @media @mobile, @ultramobile {
    flex-direction: column;
    align-items: stretch;
  }
}

.store-dropdown-wrapper {
  flex: 1;
}
